import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'Channel Opps',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  channelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  compareChannelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const channelOppsSlice = createSlice({
  name: 'channelOpps',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => ({ ...state, currentQuarter: action.payload }),
    setCurrentYear: (state, action) => ({ ...state, currentYear: action.payload }),
    setSelectedQuarter: (state, action) => ({ ...state, selectedQuarter: action.payload }),
    setSelectedYear: (state, action) => ({ ...state, selectedYear: action.payload }),
    setCompareSelectedYear: (state, action) => ({ ...state, compareSelectedYear: action.payload }),
    setCompareSelectedQuarter: (state, action) => ({
      ...state,
      compareSelectedQuarter: action.payload,
    }),
    setChannelOppsRange: (state, action) => ({ ...state, channelOppsRange: action.payload }),
    setCompareChannelOppsRange: (state, action) => ({
      ...state,
      compareChannelOppsRange: action.payload,
    }),
  },
});

export const channelOppsActions = channelOppsSlice.actions;

export default channelOppsSlice.reducer;
